(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cachet-carpet-tile-quantity"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cachet-carpet-tile-calculator')){class CachetCarpetTileCalculator extends HTMLElement{connectedCallback(){this.q=this.querySelector('[ref="quantityInput"]');this.b=this.querySelector('[data-tile-boxes]');this.a=this.querySelector('[data-tile-area]');this.t=this.querySelector('[data-tile-total]');this.ap=this.querySelector('[data-tile-property-area]');this.bp=this.querySelector('[data-tile-property-boxes]');if(!this.q)return;this.q.addEventListener('input',()=>this.update());this.q.addEventListener('change',()=>this.update());this.addEventListener('click',()=>requestAnimationFrame(()=>this.update()));this.update()}update(){const n=Math.max(1,parseInt(this.q.value,10)||1),m=parseFloat(this.dataset.boxM2)||0,p=parseInt(this.dataset.boxPrice,10)||0,area=n*m,total=n*p/100;const af=new Intl.NumberFormat('nl-NL',{minimumFractionDigits:2,maximumFractionDigits:2}),mf=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'}),bt=`${n} ${n===1?'doos':'dozen'}`,at=`${af.format(area)} m2`;this.b.textContent=bt;this.a.textContent=at;this.t.textContent=mf.format(total);this.ap.value=at;this.bp.value=bt}}customElements.define('cachet-carpet-tile-calculator',CachetCarpetTileCalculator)}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cachet-generic-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cachet-generic-quantity')) {
    class CachetGenericQuantity extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.querySelector('[ref="quantityInput"]');
        this.countOutput = this.querySelector('[data-generic-count]');
        this.totalOutput = this.querySelector('[data-generic-total]');
        this.form = this.closest('form');

        try {
          this.prices = JSON.parse(this.querySelector('[data-generic-prices]')?.textContent || '{}');
        } catch (_) {
          this.prices = {};
        }

        if (!this.quantityInput) return;

        this.quantityInput.addEventListener('input', () => this.update());
        this.quantityInput.addEventListener('change', () => this.update());
        this.addEventListener('click', () => requestAnimationFrame(() => this.update()));
        this.form?.addEventListener('change', () => setTimeout(() => this.update(), 0));
        this.update();
      }

      update() {
        const quantity = Math.max(1, Number.parseInt(this.quantityInput.value, 10) || 1);
        const variantId = this.form?.querySelector('input[name="id"]')?.value || '';
        const fallbackPrice = Number(Object.values(this.prices)[0] || 0);
        const unitPrice = Number(this.prices[variantId] || fallbackPrice);
        const currency = this.dataset.currency || 'EUR';

        this.countOutput.textContent = String(quantity);
        this.totalOutput.textContent = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format((quantity * unitPrice) / 100);
      }
    }

    customElements.define('cachet-generic-quantity', CachetGenericQuantity);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cachet-plint-quantity"] && !Shopify.designMode) return;
  try {
    if (!window.cachetPlintQuantityReady) {
    window.cachetPlintQuantityReady = true;

    const getPlintPrices = (container) => {
      try {
        return JSON.parse(container.querySelector('[data-plint-prices]')?.textContent || '{}');
      } catch (_) {
        return {};
      }
    };

    const updatePlintOrder = (container) => {
      const input = container.querySelector('input[name="quantity"]');
      if (!input) return;

      const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
      const count = container.querySelector('[data-plint-count]');
      const length = container.querySelector('[data-plint-length]');
      const total = container.querySelector('[data-plint-total]');
      const form = container.closest('form');
      const variantId = form?.querySelector('input[name="id"]')?.value || '';
      const prices = getPlintPrices(container);
      const fallbackPrice = Number(Object.values(prices)[0] || 0);
      const unitPrice = Number(prices[variantId] || fallbackPrice);
      const currency = container.dataset.currency || 'EUR';

      if (count) count.textContent = quantity === 1 ? '1 plint' : quantity + ' plinten';
      if (length) length.textContent = (quantity * 2.4).toLocaleString('nl-NL', { maximumFractionDigits: 1 }) + ' meter';
      if (total) {
        total.textContent = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format((quantity * unitPrice) / 100);
      }
    };

    const updateFromEvent = (event) => {
      const container = event.target.closest('[data-cachet-plint-order]');
      if (!container) return;
      window.requestAnimationFrame(() => updatePlintOrder(container));
    };

    document.addEventListener('click', updateFromEvent);
    document.addEventListener('input', updateFromEvent);
    document.addEventListener('change', updateFromEvent);
    document.querySelectorAll('[data-cachet-plint-order]').forEach(updatePlintOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cachet-pvc-pack-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cachet-pvc-pack-calculator')) {
    class CachetPvcPackCalculator extends HTMLElement {
      connectedCallback() {
        this.areaInput = this.querySelector('[data-pvc-area]');
        this.result = this.querySelector('[data-pvc-result]');
        this.quantityInput = this.querySelector('[ref="quantityInput"]');
        this.countOutput = this.querySelector('[data-pvc-count]');
        this.totalAreaOutput = this.querySelector('[data-pvc-total-area]');
        this.totalOutput = this.querySelector('[data-pvc-total]');
        this.form = this.closest('form');

        try {
          this.variants = JSON.parse(this.querySelector('[data-pvc-variants]')?.textContent || '{}');
        } catch (_) {
          this.variants = {};
        }

        if (!this.quantityInput) return;

        this.areaInput?.addEventListener('input', () => this.calculate());
        this.quantityInput.addEventListener('input', () => this.updateOrder());
        this.quantityInput.addEventListener('change', () => this.updateOrder());
        this.addEventListener('click', () => requestAnimationFrame(() => this.updateOrder()));
        this.form?.addEventListener('change', () => setTimeout(() => this.updateOrder(), 0));
        this.updateOrder();
      }

      currentVariant() {
        const variantId = this.form?.querySelector('input[name="id"]')?.value || '';
        return this.variants[variantId] || Object.values(this.variants)[0] || {};
      }

      updateOrder() {
        const quantity = Math.max(1, Number.parseInt(this.quantityInput.value, 10) || 1);
        const variant = this.currentVariant();
        const packM2 = Number.parseFloat(variant.pack_m2 || this.dataset.packM2 || 0);
        const price = Number.parseInt(variant.price, 10) || 0;
        const numberFormatter = new Intl.NumberFormat('nl-NL', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        const moneyFormatter = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        if (this.countOutput) this.countOutput.textContent = `${quantity} ${quantity === 1 ? 'pak' : 'pakken'}`;
        if (this.totalAreaOutput) this.totalAreaOutput.textContent = `${numberFormatter.format(quantity * packM2)} m2`;
        if (this.totalOutput) this.totalOutput.textContent = moneyFormatter.format((quantity * price) / 100);
      }

      calculate() {
        const area = Number.parseFloat(this.areaInput.value.replace(',', '.'));
        const variant = this.currentVariant();
        const packM2 = Number.parseFloat(variant.pack_m2 || this.dataset.packM2);
        const waste = Number.parseFloat(this.dataset.wastePercent);

        if (!Number.isFinite(area) || area <= 0 || !Number.isFinite(packM2) || packM2 <= 0) {
          this.result.textContent = '';
          return;
        }

        const requiredM2 = area * (1 + waste / 100);
        const packs = Math.ceil(requiredM2 / packM2);
        const deliveredM2 = packs * packM2;
        const formatter = new Intl.NumberFormat('nl-NL', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        this.quantityInput.value = packs;
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        this.result.textContent =
          `${formatter.format(requiredM2)} m2 incl. ${formatter.format(waste)}% snijverlies · ${packs} ${packs === 1 ? 'pak' : 'pakken'} = ${formatter.format(deliveredM2)} m2`;
      }
    }

    customElements.define('cachet-pvc-pack-calculator', CachetPvcPackCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
